<template>
    <div class="text-center message-banner" v-bind:class="variant">
        <button v-if="close" type="button" style="color:#FFFFFF" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <i v-if="icon" v-bind:class="icon"></i> <strong v-if="title">{{ title }}</strong><br v-if="message">{{ message }}</div>
</template>
<script>
export default {
    props: {
        icon: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: false
        },
        message: {
            type: String,
            required: false
        },
        close: {
            type: Boolean,
            default: false
        },
        variant: {
            validator: function (value) {
                // The value must match one of these strings
                return ['info','success', 'warning', 'error'].indexOf(value) !== -1
            }
        }
    }
}
</script>
<style scoped>
    .message-banner{
        padding: 10px; border-radius: 5px;
    }
    .warning{
        background: #E0A800; color: #FFF;
    }
    .error{
        background: #BB555B; color: #FFF;
    }
    .success{
        background: #229e4d; color: #FFF;
    }
    .info{
        background: #4278B1; color: #FFF;
    }
</style>
